export const recursiveSearch = (
  obj: any,
  match: string,
  searchableFields?: string[]
): boolean => {
  if (typeof obj === 'string') {
    return obj.toLowerCase().includes(match.toLowerCase());
  }
  if (Array.isArray(obj)) {
    for (const item of obj) {
      if (recursiveSearch(item, match, searchableFields)) {
        return true;
      }
    }
  } else if (typeof obj === 'object' && obj !== null) {
    for (const key of Object.keys(obj)) {
      if (!searchableFields || searchableFields.includes(key)) {
        if (recursiveSearch(obj[key], match, searchableFields)) {
          return true;
        }
      }
    }
  }
  return false;
};
